'use client';

import type { PropsWithChildren } from 'react';
import { Suspense } from 'react';
import { useSearchParams } from 'next/navigation';
import { ensureString } from '@frameio/utils/formatters';
import { useActiveAccountId } from '../ActiveEntitiesContext';
import { IsolatedActiveAccountIdContextProvider } from '../ActiveEntitiesContext/ActiveAccountIdContext';

const ACCOUNT_QUERY_PARAM = 'a';

export const useAccountIdFromQueryParam = () => {
  const searchParams = useSearchParams();

  // Read from ?a=:accountId query parameter
  let accountIdFromQueryParam: string | undefined;

  if (searchParams.has(ACCOUNT_QUERY_PARAM)) {
    accountIdFromQueryParam = ensureString(
      searchParams.get(ACCOUNT_QUERY_PARAM) ?? undefined
    );
  }

  return accountIdFromQueryParam;
};

const ForcedAccountIdFromQueryParamsThatSuspends = ({
  children,
}: PropsWithChildren) => {
  const accountIdFromQueryParam = useAccountIdFromQueryParam();
  const activeAccountId = useActiveAccountId();

  const accountId = activeAccountId || accountIdFromQueryParam;

  return (
    <IsolatedActiveAccountIdContextProvider accountId={accountId}>
      {children}
    </IsolatedActiveAccountIdContextProvider>
  );
};

export const ForcedAccountIdFromQueryParams = ({
  children,
}: PropsWithChildren) => (
  <Suspense fallback={<>{children}</>}>
    <ForcedAccountIdFromQueryParamsThatSuspends>
      {children}
    </ForcedAccountIdFromQueryParamsThatSuspends>
  </Suspense>
);
